export const SPORT_META = {
  running: { name: "Running", icon: "footprints" },
  "trail-running": { name: "Trail Running", icon: "mountain" },
  cycling: { name: "Cycling", icon: "bike" },
  triathlon: { name: "Triathlon", icon: "waves" },
  duathlon: { name: "Duathlon", icon: "activity" },
  "fitness-racing": { name: "Fitness Racing", icon: "dumbbell" },
};

export function sportName(slug) {
  return SPORT_META[slug]?.name || slug;
}

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
const MONTHS_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function parseDate(str) {
  if (!str) return null;
  const d = new Date(str + (str.length === 10 ? "T00:00:00" : ""));
  return isNaN(d) ? null : d;
}

export function dateBadge(str) {
  const d = parseDate(str);
  if (!d) return { day: "--", month: "--", year: "" };
  return { day: String(d.getDate()).padStart(2, "0"), month: MONTHS[d.getMonth()], year: String(d.getFullYear()) };
}

export function longDate(str) {
  const d = parseDate(str);
  if (!d) return "";
  return `${DAYS[d.getDay()]}, ${d.getDate()} ${MONTHS_LONG[d.getMonth()]} ${d.getFullYear()}`;
}

export function shortDate(str) {
  const b = dateBadge(str);
  return `${b.day} ${b.month} ${b.year}`;
}

export function distanceList(race) {
  const raw = (Array.isArray(race.distances) && race.distances.length)
    ? race.distances
    : (race.categories || []).map((c) => (c.distance && c.distance !== "Other" ? c.distance : c.name));
  const seen = new Set();
  const out = [];
  raw.forEach((d) => { if (d && !seen.has(d)) { seen.add(d); out.push(d); } });
  return out.slice(0, 6);
}

export const MONTHS_SELECT = MONTHS_LONG.map((m, i) => ({ value: String(i + 1).padStart(2, "0"), label: m }));

export const REG_STATUS = {
  open: { label: "Registration Open", color: "#10b981" },
  coming_soon: { label: "Coming Soon", color: "#f59e0b" },
  closed: { label: "Registration Closed", color: "#ef4444" },
};
